import { Form as FormikForm, useFormikContext } from "formik";
import React, { ReactNode, useRef } from "react";
import { useHotkeys } from "react-hotkeys-hook";

declare type AvailableTags = "INPUT" | "TEXTAREA" | "SELECT";

export enum AutoCompleteType {
    ON = "on",
    OFF = "off",
}

export const Form = ({
    children,
    autoComplete = AutoCompleteType.ON,
}: {
    children: ReactNode;
    autoComplete?: AutoCompleteType;
}) => {
    const { submitForm } = useFormikContext();
    const formRef = useRef<HTMLFormElement>(null);
    const enableOnTags: AvailableTags[] = ["INPUT", "TEXTAREA"];

    useHotkeys(
        "cmd+enter,ctrl+enter",
        (e: any) => {
            const { tagName } = e.path[0];
            if (enableOnTags.includes(tagName) && formRef.current?.contains(e.target)) {
                submitForm();
            }
        },
        { enableOnTags },
    );

    return (
        <FormikForm ref={formRef} autoComplete={autoComplete}>
            {children}
        </FormikForm>
    );
};
